import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportCheckBoxFilter = _resolveComponent("ReportCheckBoxFilter")!
  const _component_ReportSelectFilter = _resolveComponent("ReportSelectFilter")!
  const _component_ReportTimeRangeFilter = _resolveComponent("ReportTimeRangeFilter")!
  const _component_ReportSmallTimeRangeFilter = _resolveComponent("ReportSmallTimeRangeFilter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCheckboxFilter)
      ? (_openBlock(), _createBlock(_component_ReportCheckBoxFilter, {
          key: 0,
          filter: _ctx.filter,
          preselect: _ctx.preselect,
          onFilterChanged: _ctx.onFilterChanged
        }, null, 8, ["filter", "preselect", "onFilterChanged"]))
      : _createCommentVNode("", true),
    (_ctx.isSelectFilter)
      ? (_openBlock(), _createBlock(_component_ReportSelectFilter, {
          key: 1,
          filter: _ctx.filter,
          preselect: _ctx.preselect,
          onFilterChanged: _ctx.onFilterChanged
        }, null, 8, ["filter", "preselect", "onFilterChanged"]))
      : _createCommentVNode("", true),
    (_ctx.isTimeRangeFilter)
      ? (_openBlock(), _createBlock(_component_ReportTimeRangeFilter, {
          key: 2,
          filter: _ctx.filter,
          onFilterChanged: _ctx.onFilterChanged
        }, null, 8, ["filter", "onFilterChanged"]))
      : _createCommentVNode("", true),
    (_ctx.isSmallTimeRangeFilter)
      ? (_openBlock(), _createBlock(_component_ReportSmallTimeRangeFilter, {
          key: 3,
          filter: _ctx.filter,
          onFilterChanged: _ctx.onFilterChanged
        }, null, 8, ["filter", "onFilterChanged"]))
      : _createCommentVNode("", true)
  ], 64))
}